import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Toasted from "vue-toasted";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap";
import axios from "axios";
// axios.defaults.baseURL = "http://127.0.0.1:8000";
axios.defaults.baseURL = "https://note-vue-test.herokuapp.com/";
Vue.config.productionTip = false;
Vue.use(Toasted);
new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
